module.exports = __webpack_public_path__ + "716c64c9c2bbc67a22d7d9d220205cc0.png";